import {KTIcon} from '../_metronic/helpers'

function EditLabel() {
  return (
    <div className="px-3 py-2 d-flex align-items-center">
      <KTIcon iconName="pencil" className="text-success fs-6" />
      <span className="ms-2">Edit</span>
    </div>
  )
}

export default EditLabel
